import { render, staticRenderFns } from "./DispatcherForm.vue?vue&type=template&id=28466840&scoped=true&"
import script from "./DispatcherForm.vue?vue&type=script&lang=js&"
export * from "./DispatcherForm.vue?vue&type=script&lang=js&"
import style0 from "./DispatcherForm.vue?vue&type=style&index=0&id=28466840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28466840",
  null
  
)

export default component.exports